// 상수 헬퍼

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역

// =================================================================================================
// 상수
// =================================================================================================

// 개발모드 여부 겟
const isDevMode = () => {
  return __DEV__; // 변경 금지!!!
};

// 애드몹 앱 아이디
const admobAppId = {
  pett: {
    android: 'ca-app-pub-8036741446295161~8164432764',
    ios: 'ca-app-pub-8036741446295161~9381574847',
  },
};

// 애드몹 앱별 광고 단위 아이디
const admobAppAdUnitId = {
  pett: {
    android: 'ca-app-pub-8036741446295161/3532436079',
    ios: ' ca-app-pub-8036741446295161/4298722834',
  },
};

// =================================================================================================
// 내보내기
// =================================================================================================
export default {
  admobAppAdUnitId,
  admobAppId,
  isDevMode,
};
